import { ElectricalEquipment } from './electrical-equipment';

export class WaterHeater extends ElectricalEquipment {}
